import { Autocomplete, TextField } from "@mui/material";
import Cookies from "js-cookie";
import { useEffect, useRef, useState } from "react";
import { BiSolidHide, BiSolidShow } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import DynamicTable from "../../Components/Table/DynamicTable";
import {
  addClient,
  fetchCustomerData,
  UpdateCustomer,
} from "../../Redux/Slice/AddCustomer";
import { fetchAllClients } from "../../Redux/WhatsappSlice/Client";
import { fetchProjects } from "../../Redux/WhatsappSlice/Project";
import { FaCheck, FaChevronDown } from "react-icons/fa";

const customerTypes = [
  "AGENCY",
  "TRADING",
  "PROCESS HOUSE",
  "WEAVING",
  "OTHER",
];

const AddCustomer = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const { CustomerData } = useSelector((state) => state.AddCustomer);
  const { ProjectData } = useSelector((state) => state.Project);
  const { AllClients } = useSelector((state) => state.Client);

  const loginData = Cookies.get("loginData");
  const AdminData = loginData ? JSON.parse(loginData) : null;

  useEffect(() => {
    dispatch(fetchProjects());
    dispatch(fetchAllClients());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    WhaClientName: "",
    Address: "",
    ContactNo: "",
    Email: "",
    Password: "",
    Type: null,
    Project: [],
    CheckConnection: false,
    CheckVersion: false,
    StaticIP: "",
    PhysicalAddress: "",
  });

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.WhaClientName || formData.WhaClientName.length < 3) {
      newErrors.WhaClientName = "At least 3 characters";
    }

    if (!formData.Email || !/\S+@\S+\.\S+/.test(formData.Email)) {
      newErrors.Email = "Invalid email";
    }

    if (!formData.ContactNo || !/^[0-9]{10}$/.test(formData.ContactNo)) {
      newErrors.ContactNo = "10-digit number required";
    }

    if (!formData.Password || formData.Password.length < 6) {
      newErrors.Password = "At least 6 characters";
    }

    if (
      !formData.Type ||
      !["AGENCY", "TRADING", "PROCESS HOUSE", "WEAVING", "OTHER"].includes(
        formData.Type
      )
    ) {
      newErrors.Type = "Invalid Type";
    }

    if (formData.Project.length === 0) {
      newErrors.Project = "At least one project must be selected";
    }

    if (!formData.PhysicalAddress || !formData.StaticIP.trim()) {
      newErrors.StaticIP = "Static IP is required";
    } else {
      const onlyNumberRegex = /^[0-9.]+$/;
      if (!onlyNumberRegex.test(formData.StaticIP.trim())) {
        newErrors.StaticIP = "Only numbers are allowed in Static IP";
      }
    }

    if (!formData.PhysicalAddress || !formData.PhysicalAddress.trim()) {
      newErrors.PhysicalAddress = "Physical Address is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [showPassword, setShowPassword] = useState(false);
  const [editing, setEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    dispatch(fetchCustomerData());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTypeChange = (event, newValue) => {
    setFormData((prev) => ({ ...prev, Type: newValue }));
  };

  const handleProjectChange = (id) => {
    const selected = formData?.Project || [];
    const updated = selected.includes(id)
      ? selected.filter((item) => item !== id)
      : [...selected, id];

    setFormData((prev) => ({
      ...prev,
      Project: updated,
    }));
  };

  const selectedNames =
    formData?.Project?.length > 0
      ? formData.Project.map((id) => {
        const project = ProjectData.find((p) => p._id === id);
        return project?.project_name;
      }).join(", ")
      : "Select Project";

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const validationErrors = validateForm(formData);
  //   setErrors(validationErrors);

  //   // const data = {
  //   //   ...formData,
  //   // };

  //   if (editing) {
  //     dispatch(UpdateCustomer({ id: editingId, data: formData })).then(() => {
  //       dispatch(fetchCustomerData());
  //       resetForm();
  //     });
  //   } else {
  //     // dispatch(AddNewCustomer(data)).then(() => {
  //     //   dispatch(fetchCustomerData());
  //     //   resetForm();
  //     // });
  //     dispatch(addClient({ values: formData, loginData: AdminData })).then(
  //       () => {
  //         dispatch(fetchCustomerData());
  //         resetForm();
  //       }
  //     );
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      toast.error("Please fix the validation errors.");
      return;
    }

    if (editing) {
      dispatch(UpdateCustomer({ id: editingId, data: formData }))
        .then(() => {
          dispatch(fetchAllClients());
          toast.success("Customer updated successfully!");
          resetForm();
        })
        .catch(() => {
          toast.error("Failed to update customer.");
        });
    } else {
      dispatch(addClient({ values: formData, loginData: AdminData }))
        .then(() => {
          dispatch(fetchAllClients());
          toast.success("Customer added successfully!");
          resetForm();
        })
        .catch(() => {
          toast.error("Failed to add customer.");
        });
    }
  };

  const resetForm = () => {
    setFormData({
      WhaClientName: "",
      Address: "",
      ContactNo: "",
      Email: "",
      Password: "",
      PhysicalAddress: "",
      StaticIP: "",
    });
    setEditing(false);
    setEditingId(null);
    setErrors({});
  };

  const handleEdit = (customer) => {
    setEditing(true);
    setEditingId(customer.Mainid); // assuming Mainid is _id

    setFormData({
      WhaClientName: customer?.WhaClientName || "-",
      Address: customer?.Address || "-",
      ContactNo: customer?.MobileNumber || "-",
      Email: customer?.Email || "-",
      Password: customer?.Password || "-",
      Type: customer?.Type || "-",
      Project: customer?.Project?.map((proj) => proj._id) || [],
      StaticIP: customer?.StaticIP || "-",
      PhysicalAddress: customer?.PhysicalAddress || "-",
      CheckConnection: customer?.CheckConnection || false,
      CheckVersion: customer?.CheckVersion || false,
    });

    setErrors({});
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "WhaClientName", headerName: "Company Name", flex: 1 },
    // { field: "AdminID", headerName: "Company Name", flex: 1 },
    { field: "Email", headerName: "Email", flex: 1 },
    { field: "MobileNumber", headerName: "Mobile Number", flex: 1 },
    { field: "Type", headerName: "Type", flex: 1 },
    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => (
        <button
          onClick={() => handleEdit(params.row)}
          className="py-2 px-3 text-white rounded-md bg-[#122A47]"
        >
          Edit
        </button>
      ),
    },
  ];

  const rows =
    AllClients?.data?.map((el, index) => ({
      id: el.id || index + 1,
      Mainid: el?._id,
      WhaClientName: el?.WhaClientName,
      // AdminID: el?.AdminID,
      Project:
        el?.Project?.map((e) => ({
          _id: e._id,
          project_name: e.project_name,
        })) || [],
      MobileNumber: el?.ContactNo || "-",
      Email: el?.Email || "-",
      Address: el?.Address,
      Password: el?.Password,
      Type: el?.Type,
      PhysicalAddress: el?.PhysicalAddress,
      StaticIP: el?.StaticIP,
      CheckConnection: el?.CheckConnection || false,
      CheckVersion: el?.CheckVersion || false,
    })) || [];

  return (
    <>
      <div>
        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
          Add Customer
        </h3>
        <form
          onSubmit={handleSubmit}
          className="Form_bg_color bg-white shadow-md rounded-md mt-4"
        >
          <div className="grid grid-cols-12 gap-4 p-2">
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <label className="font-semibold block mb-1">Company Name</label>
              <input
                name="WhaClientName"
                value={formData.WhaClientName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 rounded border-2 border-black"
                placeholder="Enter customer name"
              />
              {errors.WhaClientName && (
                <p className="text-red-500">{errors.WhaClientName}</p>
              )}
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="block mb-1 font-semibold">Admin Name</h5>
              {/* <input type="hidden" name="AdminID" value={formData.AdminID} /> */}
              <input
                type="text"
                placeholder="Enter version number"
                value={AdminData?.data?.Name}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
                readOnly
              />
            </div>

            {/* Project Dropdown */}
            <div
              className="col-span-12 lg:col-span-4 md:col-span-6"
              ref={dropdownRef}
            >
              {/* Label */}
              <label className="block text-sm font-semibold mb-1">
                Select Project
              </label>

              {/* Dropdown Button */}
              <div
                onClick={() => setOpen(!open)}
                className={`flex items-center justify-between cursor-pointer 
          bg-[#F3F8FB] border-2 rounded px-3 py-2
          transition-all
          ${errors.Project ? "border-red-500" : "border-black"}`}
              >
                <span className="text-sm truncate">{selectedNames}</span>
                <FaChevronDown
                  className={`text-sm transition-transform ${open ? "rotate-180" : ""
                    }`}
                />
              </div>

              {/* Dropdown List */}
              {open && (
                <div className="relative w-full">
                  <div className="absolute z-50 mt-1 w-full bg-white border rounded shadow max-h-60 overflow-y-auto">
                    {ProjectData.length === 0 && (
                      <p className="px-3 py-2 text-sm text-gray-500">
                        No projects found
                      </p>
                    )}

                    {[...(ProjectData || [])]
                      .sort((a, b) => (a.project_name || "").localeCompare(b.project_name || ""))
                      .map((project) => {
                        const checked = formData?.Project?.includes(project._id);

                        return (
                          <div
                            key={project._id}
                            onClick={() => handleProjectChange(project._id)}
                            className={`flex items-center justify-between px-3 py-2 cursor-pointer
                  transition-all
                  ${checked
                                ? "bg-[#DCEBFA] text-[#122A47] font-semibold"
                                : "hover:bg-gray-100"
                              }`}
                          >
                            <span className="text-sm">
                              {project.project_name}
                            </span>

                            {checked && (
                              <FaCheck className="text-[#122A47] text-sm" />
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              )}

              {/* Error */}
              {errors.Project && (
                <p className="text-red-500 text-xs mt-1">{errors.Project}</p>
              )}
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <label className="font-semibold block mb-1">
                Enter Your Email
              </label>
              <input
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                type="email"
                className="bg-[#F3F8FB] w-full p-2 rounded border-2 border-black"
                placeholder="Enter Your Email"
              />
              {errors.Email && <p className="text-red-500">{errors.Email}</p>}
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6 relative">
              <label className="font-semibold block mb-1">
                Enter a Password
              </label>
              <input
                id="passwordInput"
                name="Password"
                type={showPassword ? "text" : "password"}
                value={formData.Password}
                onChange={handleChange}
                className="w-full border-2 border-black p-2 rounded pr-12 Form_bg_color"
                placeholder="Password"
              />
              {errors.Password && (
                <p className="text-red-500">{errors.Password}</p>
              )}
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-[6%] top-[70%] transform -translate-y-1/2 text-sm text-gray-600"
              >
                {showPassword ? (
                  <BiSolidHide size={20} />
                ) : (
                  <BiSolidShow size={20} />
                )}
              </button>
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <label className="font-semibold block mb-1">Address</label>
              <input
                name="Address"
                value={formData.Address}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 rounded border-2 border-black"
                placeholder="Enter Address"
              />
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <label className="font-semibold block mb-1">Contact Number</label>
              <input
                type="number"
                name="ContactNo"
                value={formData.ContactNo}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 rounded border-2 border-black"
                placeholder="Enter Contact Number"
              />
              {errors.ContactNo && (
                <p className="text-red-500">{errors.ContactNo}</p>
              )}
            </div>

            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <label className="font-semibold block mb-1">Type</label>
              <Autocomplete
                options={customerTypes} // plain string array
                value={formData.Type}
                onChange={handleTypeChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="custom-input"
                    placeholder="Select Type"
                    size="small"
                  />
                )}
              />
              {errors.Type && <p className="text-red-500">{errors.Type}</p>}
            </div>

            {/* Static IP Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Static IP</h5>
              <input
                type="text"
                name="StaticIP"
                placeholder="Enter Static IP Number"
                value={formData.StaticIP}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.StaticIP && (
                <p className="text-red-500 text-sm">{errors.StaticIP}</p>
              )}
            </div>

            {/* Physical Address Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Physical Address</h5>
              <input
                type="text"
                name="PhysicalAddress"
                placeholder="Enter Physical Address"
                value={formData.PhysicalAddress}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.PhysicalAddress && (
                <p className="text-red-500 text-sm">{errors.PhysicalAddress}</p>
              )}
            </div>

            <div className="col-span-12 xl:col-span-2 lg:col-span-3 md:col-span-6">
              <div className="gap-4 justify-center items-center">
                {/* Check Connection */}
                <div className="flex items-center mt-4 space-x-2">
                  <input
                    id="CheckConnection"
                    type="checkbox"
                    name="CheckConnection"
                    checked={formData.CheckConnection || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        CheckConnection: e.target.checked,
                      }))
                    }
                    className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                  />
                  <label
                    htmlFor="CheckConnection"
                    className="text-base font-semibold"
                  >
                    Check Connection
                  </label>
                </div>

                {/* Check Version */}
                <div className="flex items-center mt-2 space-x-2">
                  <input
                    id="CheckVersion"
                    type="checkbox"
                    name="CheckVersion"
                    checked={formData.CheckVersion || false}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        CheckVersion: e.target.checked,
                      }))
                    }
                    className="appearance-none w-6 h-6 border-2 border-black rounded-sm checked:bg-[#133a69] checked:border-blue-500 "
                  />
                  <label
                    htmlFor="CheckVersion"
                    className="text-base font-semibold"
                  >
                    Check Version
                  </label>
                </div>
              </div>
            </div>

            <div className="col-span-12 md:col-span-12 flex justify-center items-center">
              <button
                type="submit"
                className="bg-[#122A47] text-white py-2 px-2 md:px-4 rounded hover:bg-[#0c2545]"
              >
                {editing ? "UPDATE MEMBER" : "ADD CUSTOMER"}
              </button>
              {editing && (
                <button
                  type="button"
                  onClick={resetForm}
                  className="ml-2 bg-gray-400 text-white py-2 px-2 md:px-4 rounded hover:bg-gray-600"
                >
                  CANCEL
                </button>
              )}
            </div>
          </div>
        </form>

        <div className="my-6">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            Recent Members
          </h3>
          <div className="mt-5">
            <DynamicTable rows={rows} columns={columns} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCustomer;
